import PlaceholderImage from "comps/PlaceholderImage"
import SectionTitle from "comps/SectionTitle"
import { MediaQueryContext } from "libs/contexts"
import { range } from "libs/utils"
import { useContext } from "react"
import { cls } from "reactutils"
import HomeTitle from '@/comps/HomeTitle'
import BrandPicsBg from '@/images/cscec3b/home/brand-pics-bg.png'

export default function BrandPics({
  brands,
  title,
}: {
  brands: Array<{
    image: string
    link: string
    title: string
  }>
  title: string
}) {
  const { phoneBreakpoint } = useContext(MediaQueryContext)
  const { isMobile } = useContext(MediaQueryContext)
  const placeholders = (4 - (brands.length % 4)) % 4
  const imgHeight = !isMobile ? 246 : "100%"
  const imgWidth = !isMobile ? 276 : "100%"

  return (
    <div className="brand-pics">
      {!isMobile ? (
        <HomeTitle title={title} />
      ) : (
        <SectionTitle
          title={title}
          styles={{ marginBottom: 20, marginTop: 40 }}
        />
      )}
      <div className={cls("pic-container", !isMobile && "pic-new")}>
        {brands.map((v, index) => (
          <a
            className="img-link"
            key={index}
            rel="noreferrer"
            onClick={() => {
              window.open(v.link || undefined, !isMobile ? "_blank" : "_top")
            }}
          >
            <PlaceholderImage
              height={imgHeight}
              width={imgWidth}
              src={v.image}
              alt={v.title}
            />
          </a>
        ))}
        {range(placeholders).map((holder) => (
          <div key={holder} className="img-link range-item" />
        ))}
      </div>
      <style jsx>{`
        .brand-pics {
          padding: 40px 0 80px;
          background-image: url(${BrandPicsBg});
          background-size: cover;
        }
        .title {
          width: 1200px;
          margin: 0 auto;
          margin-top: 50px;
          margin-bottom: 30px;
          font-size: 28px;
          line-height: 28px;
          font-weight: 500;
          color: #333333;
        }
        .pic-container {
          display: flex;
          justify-content: space-between;
          width: 1200px;
          margin: 0 auto;
          flex-wrap: wrap;
        }

        .img-link {
          height: 246px;
          width: 276px;
        }
        .pic-new .img-link:not(.range-item) {
          border-radius: 6px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
          overflow: hidden;
        }
      `}</style>
      <style jsx>{`
        @media ${phoneBreakpoint} {
          .pic-container {
            margin: 0 16px;
            width: auto;
            overflow: hidden;
            background: #fff;
            margin-bottom: 20px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            position: relative;
          }

          .img-link {
            height: 42px;
            position: relative;
            overflow: hidden;
            border-radius: 1px;
            flex: 1 1 auto;
            width: calc(25% - 1px);
          }

          .img-link {
            margin-bottom: 1px;
            margin-right: 1px;
          }

          .img-link:nth-of-type(4n) {
            margin-right: 0;
          }

          .img-link:nth-of-type(n + 4) {
            margin-bottom: 0;
          }

          .img-link.range-item {
            margin-bottom: 0;
          }

          .img-link:nth-of-type(-n + 4)::before {
            content: "";
            position: absolute;
            width: 100%;
            height: 1px;
            background: #f1f1f1;
            bottom: 0;
            left: 0;
          }

          .img-link:not(:nth-of-type(4n))::after {
            position: absolute;
            content: "";
            width: 1px;
            height: 100%;
            background: #f1f1f1;
            bottom: 0;
            right: 0;
          }
        }
      `}</style>
    </div>
  )
}

export function toProps(data, getPublicUrl) {
  return data.map((entity) => ({
    image: getPublicUrl(entity.image),
    link: entity.link,
    title: entity.title,
  }))
}
